'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import CustomWidgetPropTypes from 'DesignData/propTypes/customWidgets';
import { connect } from 'react-redux';
import { getHasGlobalContentEditorAccess } from 'DesignData/selectors/auth';
import * as CustomWidgetBufferActions from 'DesignData/actions/CustomWidgetBuffers';
import * as CustomWidgetEditorOptionsActions from 'DesignData/actions/CustomWidgetEditorOptions';
import * as SfdcIntegrationStatusActions from 'DesignData/actions/SalesforceIntegrationStatus';
import { getUserHasReadAccessOnly } from 'DesignData/selectors/auth';
import * as customWidgetEditorOptionsSelectors from 'DesignData/selectors/customWidgetEditorOptions';
import * as customWidgetBuffersSelectors from 'DesignData/selectors/customWidgetBuffers';
import { getIsProjectsFile } from 'DesignData/selectors/finder';
import { EDIT, CREATE } from 'DesignData/enums/CustomWidgetFieldTypePermissions';
import CustomWidgetField from 'DesignData/models/CustomWidgetField';
import FieldEditSidebar from 'DesignEditorsUI/components/customWidgetEditor/sidebar/fieldEdit/FieldEditSidebar';
import { STYLE } from 'ContentUtils/constants/CustomWidgetFieldGroupTabTypes';

function makeMapStateToProps() {
  const getCustomWidgetBuffer = customWidgetBuffersSelectors.makeGetCustomWidgetBuffer();
  const getCustomWidgetBufferFields = customWidgetBuffersSelectors.makeGetCustomWidgetBufferFields();
  const getFieldTypePermissions = customWidgetEditorOptionsSelectors.makeGetFieldTypePermissions();
  const getIsEmailOrAnyType = customWidgetBuffersSelectors.makeGetIsEmailOrAnyType();
  const getIsReadOnly = customWidgetBuffersSelectors.makeGetIsReadOnly();
  return (state, props) => {
    const customWidgetBuffer = getCustomWidgetBuffer(state, props);
    const {
      isActive
    } = customWidgetEditorOptionsSelectors.getFieldGrouping(state, props);
    const fieldTypePermissions = getFieldTypePermissions(state, props);
    const selectedField = customWidgetEditorOptionsSelectors.getSelectedField(state, props);
    const isEditingGlobalContent = customWidgetEditorOptionsSelectors.getIsEditingGlobalContent(state, props);
    const canEditFieldType = !!(selectedField.field && fieldTypePermissions[selectedField.field.type][EDIT]);
    return Object.assign({
      customWidgetId: props.customWidgetId,
      isReadOnly: getUserHasReadAccessOnly(state) || getIsReadOnly(state, props) || isEditingGlobalContent || !canEditFieldType || getIsProjectsFile(state, {
        fileId: props.customWidgetId
      }),
      fieldErrors: customWidgetEditorOptionsSelectors.getFieldErrors(state, props),
      fieldWarnings: customWidgetEditorOptionsSelectors.getFieldWarnings(state, props),
      fieldBreadcrumbs: customWidgetEditorOptionsSelectors.getSelectedFieldBreadcrumbs(state, props),
      fields: getCustomWidgetBufferFields(state, props),
      isFieldGroupingActive: !!isActive,
      isFullScreenEditorOpen: customWidgetEditorOptionsSelectors.getIsFullScreenEditorOpen(state, props),
      customWidgetContentTypes: customWidgetBuffer ? customWidgetBuffer.contentTypes : null,
      customWidgetHostTemplateTypes: customWidgetBuffer ? customWidgetBuffer.hostTemplateTypes : null,
      customWidgetIcon: customWidgetBuffer ? customWidgetBuffer.icon : null,
      isGlobal: customWidgetBuffer ? customWidgetBuffer.global : false,
      isV1: customWidgetBuffer ? customWidgetBuffer.schemaVersion === 1 : false,
      accordionStates: customWidgetEditorOptionsSelectors.getAccordionStates(state, props),
      canEditFieldType,
      canCreateFieldType: !!(selectedField.field && fieldTypePermissions[selectedField.field.type][CREATE]),
      isEmailOrAnyType: getIsEmailOrAnyType(state, props),
      customWidgetPath: customWidgetBuffer ? customWidgetBuffer.path : '',
      hasGlobalContentEditorAccess: getHasGlobalContentEditorAccess(state, props)
    }, selectedField);
  };
}

const mapDispatchToProps = {
  cloneField: CustomWidgetBufferActions.cloneField,
  deleteField: CustomWidgetBufferActions.deleteField,
  editField: CustomWidgetBufferActions.editField,
  setSelectedField: CustomWidgetEditorOptionsActions.setSelectedField,
  saveAccordionState: CustomWidgetEditorOptionsActions.saveAccordionState,
  fetchSfdcIntegrationStatus: SfdcIntegrationStatusActions.fetch,
  setFullScreenEditorOpen: CustomWidgetEditorOptionsActions.setFullScreenEditorOpen
};

class FieldEditSidebarContainer extends Component {
  constructor(...args) {
    super(...args);

    this.saveAccordionState = (key, isOpen = false) => {
      this.props.saveAccordionState(this.props.customWidgetId, key, isOpen, this.props.field.id);
    };

    this.isStyleTab = this.props.fieldBreadcrumbs[0] && this.props.fieldBreadcrumbs[0].tab === STYLE;
  }

  componentDidMount() {
    this.props.fetchSfdcIntegrationStatus();
  }

  render() {
    const {
      customWidgetContentTypes,
      customWidgetHostTemplateTypes,
      customWidgetIcon,
      customWidgetId,
      customWidgetPath,
      editField,
      field,
      fieldErrors,
      fieldWarnings,
      fieldBreadcrumbs,
      setSelectedField,
      isFieldGroupingActive,
      isFullScreenEditorOpen,
      accordionStates,
      canEditFieldType,
      canCreateFieldType,
      isGlobal,
      cloneField,
      deleteField,
      isReadOnly,
      isV1,
      setFullScreenEditorOpen,
      isEmailOrAnyType,
      hasGlobalContentEditorAccess
    } = this.props;
    return /*#__PURE__*/_jsx(FieldEditSidebar, {
      canEditFieldType: canEditFieldType,
      canCreateFieldType: canCreateFieldType,
      customWidgetContentTypes: customWidgetContentTypes,
      customWidgetHostTemplateTypes: customWidgetHostTemplateTypes,
      customWidgetIcon: customWidgetIcon,
      customWidgetId: customWidgetId,
      customWidgetPath: customWidgetPath,
      cloneField: cloneField,
      deleteField: deleteField,
      editField: editField,
      field: field,
      isStyleTab: this.isStyleTab,
      fieldBreadcrumbs: fieldBreadcrumbs,
      fieldErrors: fieldErrors,
      fieldWarnings: fieldWarnings,
      isEmailOrAnyType: isEmailOrAnyType,
      isFieldGroupingActive: isFieldGroupingActive,
      isFullScreenEditorOpen: isFullScreenEditorOpen,
      isGlobal: isGlobal,
      setSelectedField: setSelectedField,
      saveAccordionState: this.saveAccordionState,
      accordionStates: accordionStates,
      readOnly: isReadOnly,
      isV1: isV1,
      setFullScreenEditorOpen: setFullScreenEditorOpen,
      hasGlobalContentEditorAccess: hasGlobalContentEditorAccess
    });
  }

}

FieldEditSidebarContainer.propTypes = {
  customWidgetContentTypes: PropTypes.array,
  customWidgetHostTemplateTypes: PropTypes.array,
  customWidgetIcon: PropTypes.string,
  customWidgetId: CustomWidgetPropTypes.customWidgetId.isRequired,
  customWidgetPath: PropTypes.string.isRequired,
  cloneField: PropTypes.func.isRequired,
  deleteField: PropTypes.func.isRequired,
  editField: PropTypes.func.isRequired,
  field: PropTypes.instanceOf(CustomWidgetField),
  fieldBreadcrumbs: PropTypes.array.isRequired,
  fieldErrors: PropTypes.object.isRequired,
  fieldWarnings: PropTypes.object.isRequired,
  isEmailOrAnyType: PropTypes.bool.isRequired,
  isFieldGroupingActive: PropTypes.bool.isRequired,
  isFullScreenEditorOpen: PropTypes.bool.isRequired,
  isGlobal: PropTypes.bool,
  setSelectedField: PropTypes.func.isRequired,
  saveAccordionState: PropTypes.func.isRequired,
  accordionStates: PropTypes.object.isRequired,
  canEditFieldType: PropTypes.bool.isRequired,
  canCreateFieldType: PropTypes.bool.isRequired,
  isReadOnly: PropTypes.bool.isRequired,
  fetchSfdcIntegrationStatus: PropTypes.func.isRequired,
  isV1: PropTypes.bool.isRequired,
  setFullScreenEditorOpen: PropTypes.func.isRequired,
  hasGlobalContentEditorAccess: PropTypes.bool.isRequired
};
FieldEditSidebarContainer.defaultProps = {
  customWidgetContentTypes: null,
  customWidgetHostTemplateTypes: null,
  customWidgetIcon: null,
  field: null,
  accordionStates: {}
};
export default connect(makeMapStateToProps, mapDispatchToProps)(FieldEditSidebarContainer);